import createAsyncActionType from '../utilities/createAsyncActionType';

export const GET_WATCH_LISTS = createAsyncActionType('GET_WATCH_LISTS');


// WEBPACK FOOTER //
// ./src/types/watchListTypes.js